










import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Model } from "vue-property-decorator";

@Component
export default class Textbox extends Vue {
  name: "Textbox";

  @Model("input-text", { type: String, default: "" })
  value: string;

  @Prop({ required: true })
  public id!: string;

  @Prop({ default: "text" })
  public inputType!: string;

  get inputValue() {
    return this.value;
  }
  set inputValue(value) {
    this.$emit("input-text", value);
  }

  private onKeyDownEnter(): void {
    this.$emit("key-down-enter");
  }
}
